import { type ComponentPropsWithoutRef } from 'react';

import { cn } from '@/utils/cn';

export type SafeAreaProps = ComponentPropsWithoutRef<'div'>;

/**
 * Pads the layout edges with `env(safe-area-inset-*)` so header content clears a notch and footer
 * content clears a home indicator. Used by `CashierLayout`; sticky CTAs have their own inset on
 * `StickyActionBar` because they sit outside this wrapper.
 */
export function SafeArea({ className, ...rest }: SafeAreaProps) {
  return (
    <div
      className={cn(
        'ps-[env(safe-area-inset-left)] pe-[env(safe-area-inset-right)] pt-[env(safe-area-inset-top)]',
        className,
      )}
      {...rest}
    />
  );
}
